
import { Code, Computer, Award, Book, Users } from "lucide-react";
import { Skill, ProgressData } from "./types";

export const skills: Skill[] = [
  {
    id: 1,
    name: "Web Development",
    icon: Code,
    description: "Master HTML, CSS, JavaScript, React, and modern web frameworks. Build responsive and dynamic web applications.",
    questionsCount: 40,
    duration: "60 minutes",
    difficulty: "Intermediate",
    category: "Development",
    popularity: 95,
    certificateAvailable: true,
    prerequisites: ["Basic HTML/CSS", "JavaScript Fundamentals"],
    topicsCount: 8,
    completionRate: 76
  },
  {
    id: 2,
    name: "UI/UX Design",
    icon: Computer,
    description: "Learn design thinking, user research, wireframing, prototyping, and usability testing methodologies.",
    questionsCount: 35,
    duration: "45 minutes",
    difficulty: "Advanced",
    category: "Design",
    popularity: 88,
    certificateAvailable: true,
    prerequisites: ["Basic Design Principles", "Figma/Sketch"],
    topicsCount: 6,
    completionRate: 82
  },
  {
    id: 3,
    name: "Digital Marketing",
    icon: Award,
    description: "Master SEO, social media marketing, content strategy, and analytics. Drive traffic and engagement.",
    questionsCount: 30,
    duration: "40 minutes",
    difficulty: "Beginner",
    category: "Marketing",
    popularity: 92,
    certificateAvailable: true,
    prerequisites: ["Basic Marketing Concepts"],
    topicsCount: 5,
    completionRate: 88
  },
  {
    id: 4,
    name: "Data Science",
    icon: Book,
    description: "Learn Python, statistics, machine learning, and data visualization. Make data-driven decisions.",
    questionsCount: 45,
    duration: "75 minutes",
    difficulty: "Advanced",
    category: "Development",
    popularity: 90,
    certificateAvailable: true,
    prerequisites: ["Python Basics", "Statistics"],
    topicsCount: 10,
    completionRate: 65
  },
  {
    id: 5,
    name: "Project Management",
    icon: Users,
    description: "Master Agile, Scrum, and traditional project management methodologies. Lead teams effectively.",
    questionsCount: 35,
    duration: "50 minutes",
    difficulty: "Intermediate",
    category: "Management",
    popularity: 85,
    certificateAvailable: true,
    prerequisites: ["Team Leadership", "Basic PM Concepts"],
    topicsCount: 7,
    completionRate: 79
  }
];

export const progressData: ProgressData[] = [
  { name: "Web Dev", completed: 85, total: 100 },
  { name: "UI/UX", completed: 65, total: 100 },
  { name: "Marketing", completed: 75, total: 100 },
  { name: "Data Science", completed: 45, total: 100 },
  { name: "Project Mgmt", completed: 60, total: 100 },
];

export const categories = ["All", "Development", "Design", "Marketing", "Management"];
export const difficulties = ["All", "Beginner", "Intermediate", "Advanced"];
